/*global google*/
import ReactDOM from "react-dom";
import CloseImage from '../../assets/ic_close.png';
import setting from '../../assets/ic_web_setting.png';
import React from "react";

import { GoogleMap, DirectionsRenderer, Marker, InfoWindow } from "@react-google-maps/api";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
    geocodeByPlaceId
} from 'react-places-autocomplete';
import Geocode from "react-geocode";
import Constant from "../../library/Constant";
import { Typography } from "@material-ui/core";

const defaultLocation = { lat: -6.2278787, lng: 106.8255871 };
let destination = { lat: -6.2278787, lng: 106.8255871 };
let origin = { lat: -6.1955107, lng: 106.8513711 };
let directionsService;
class Map extends React.Component {
    state = {
        directions: null,
        bounds: null,
        jarak: "",
        distance: null,
        address: '',
        lng: '',
        lat: '',
        markerlat: '',
        markerlng: '',
        durasi: '',
    };

    onMapLoad = (origin, destination, intent) => {
        directionsService = new google.maps.DirectionsService();
        //load default origin and destination
        this.changeDirection(origin, destination, intent);
    };

    //function that is calling the directions service
    changeDirection = (origin, destination, intent) => {
        directionsService.route(
            {
                origin: origin,
                destination: destination,
                travelMode: google.maps.TravelMode.DRIVING
            },
            (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    Geocode.setApiKey(Constant.API_KEY_GOOGLE);
                    Geocode.setLanguage("en");
                    Geocode.setRegion("id");
                    Geocode.setLocationType("ROOFTOP");
                    Geocode.enableDebug();
                    Geocode.fromLatLng(this.state.lat, this.state.lng).then(
                        (response) => {
                            if (intent === '') {
                                const address = response.results[0].formatted_address;
                                console.log(address);
                                this.setState({ address })
                            }
                        },
                        (error) => {
                            console.error(error);
                        }
                    );
                    //changing the state of directions to the result of direction service
                    this.setState({
                        directions: result,
                        jarak: result.routes[0].legs[0].distance.text,
                        distance: result.routes[0].legs[0].distance.value,
                        durasi: result.routes[0].legs[0].duration.text,
                    });
                    console.log(result);
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            }
        );
    };

    componentDidMount() {
        if (this.props.saveDataMap !== null) {
            let destination = { lat: Number(this.props.saveDataMap.lat), lng: Number(this.props.saveDataMap.lng) }
            this.onMapLoad(origin, destination, '')
            this.setState({ address: this.props.saveDataMap.address, lat: destination.lat, lng: destination.lng })
        }
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSave() {
        this.props.setSaveDataMap({
            jarak: this.state.jarak,
            distance: this.state.distance,
            address: this.state.address,
            lng: this.state.lng,
            lat: this.state.lat,
            durasi: this.state.durasi
        })
        this.props.onClose()
    }

    handleSelect = (address, placeID) => {
        console.log(address, placeID);
        geocodeByPlaceId(placeID).then(results => {
            let lat = results[0].geometry.location.lat()
            let lng = results[0].geometry.location.lng()
            let destination = { lat: lat, lng: lng }
            this.onMapLoad(origin, destination, 'search')
            this.setState({ lat, lng, address })
        });
        // geocodeByAddress(address).then(results => getLatLng(results[0]))
        //     .then(({ lat, lng }) =>
        //     //   console.log('Successfully got latitude and longitude', { lat, lng })
        //     {
        //         let destination = { lat: lat, lng: lng }
        //         this.onMapLoad(origin, destination)
        //         this.setState({ lat, lng, address })
        //     });
        // geocodeByAddress(address)
        //     .then(results => {
        //         console.log(results);
        //         getLatLng(results[0])
        //     })
        //     .then(latLng => console.log('Success', latLng))
        //     .catch(error => console.error('Error', error));
    };

    handleClick = (event) => {
        var lat = event.latLng.lat(), lng = event.latLng.lng()
        Geocode.setApiKey(Constant.API_KEY_GOOGLE);
        Geocode.setLanguage("en");
        Geocode.setRegion("id");
        Geocode.setLocationType("ROOFTOP");
        Geocode.enableDebug();
        Geocode.fromLatLng(lat, lng).then(
            (response) => {
                const address = response.results[0].formatted_address;
                console.log(address);
                this.setState({ markerlat: lat, markerlng: lng })
            },
            (error) => {
                console.error(error);
            }
        );
    }

    handleDrag = (event) => {
        var lat = event.latLng.lat(), lng = event.latLng.lng()
        Geocode.setApiKey(Constant.API_KEY_GOOGLE);
        Geocode.setLanguage("en");
        Geocode.setRegion("id");
        Geocode.setLocationType("ROOFTOP");
        Geocode.enableDebug();
        Geocode.fromLatLng(lat, lng).then(
            (response) => {
                const address = response.results[0].formatted_address;
                console.log(address);
                this.setState({ markerlat: lat, markerlng: lng })
            },
            (error) => {
                console.error(error);
            }
        );
    }

    handleClickMarker = (event) => {
        var lat = event.latLng.lat(), lng = event.latLng.lng()
        let destination = { lat: lat, lng: lng }
        this.setState({ markerlat: '', markerlng: '', lat, lng })
        this.onMapLoad(origin, destination, '')
    }

    render() {
        return (
            <div className="App app-popup-show">
                <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
                    <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8, background: '#278863' }}>
                        <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                            <div className="popup-title" >
                                <span style={{ color: 'black', fontSize: 18, color: 'white' }}>Pilih Lokasi</span>
                            </div>
                        </div>
                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                            <button
                                type="button"
                                className="btn btn-circle btn-white"
                                onClick={() => this.props.onClose()}
                            >
                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                            </button>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 20px 0' }}>
                        {/* <Autocomplete
                            style={{ zIndex: 1000 }}
                            apiKey={Constant.API_KEY_GOOGLE}
                            onPlaceSelected={(place) => {
                                console.log(place);
                            }}
                        /> */}
                        <PlacesAutocomplete
                            value={this.state.address}
                            onChange={this.handleChange}
                            onSelect={this.handleSelect}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div style={{ fontSize: 18, width: 630, height: 30, display: 'flex', justifyContent: 'center' }}>
                                    <input
                                        {...getInputProps({
                                            placeholder: 'Search Places ...',
                                            className: 'location-search-input',
                                        })}
                                    />
                                    <div className="autocomplete-dropdown-container">
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                        style,
                                                    })}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                        <div onClick={(e) => this.handleSave()} style={{ height: 33, width: 100, backgroundColor: '#278863', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Typography style={{ color: 'white', fontSize: 13 }}>Pilih</Typography>
                        </div>
                    </div>
                    <div style={{ display: 'flex', marginTop: 10, justifyContent: 'space-between', padding: '0 20px' }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ textAlign: 'left', padding: '10px 00px 10px', paddingRight: 25, color: '#868686' }}>
                                Jarak : {this.state.jarak}
                            </div>
                            <div style={{ textAlign: 'left', padding: '10px 20px 10px', color: '#868686' }}>
                                Durasi : {this.state.durasi}
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: 20, paddingTop: 0 }}>
                        <GoogleMap
                            center={defaultLocation}
                            zoom={15}

                            onClick={(e) => this.handleClick(e)}
                            // onLoad={map => this.onMapLoad(origin, destination)}
                            mapContainerStyle={{ height: "400px", width: "758px" }}
                        >
                            <Marker
                                draggable={true}
                                title={this.state.address}
                                onDragEnd={(e) => this.handleDrag(e)}
                                position={{ lat: this.state.markerlat, lng: this.state.markerlng }}
                                onClick={(e) => this.handleClickMarker(e)} />
                            {this.state.isOpen && (
                                <InfoWindow>
                                    <span>Something</span>
                                </InfoWindow>
                            )}
                            {this.state.directions !== null && (
                                <DirectionsRenderer directions={this.state.directions}
                                // options={{
                                //     markerOptions: { icon: setting },
                                //     icon: { scale: 1, size: 12 }
                                // }}
                                />
                            )}
                        </GoogleMap>
                    </div>
                </div>
            </div>
        );
    }
}

export default Map;

// import React from "react"
// import { compose, withProps } from "recompose"
// import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
// import Constant from '../../library/Constant';

// const MyMapComponent = compose(
//     withProps({
//         googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${Constant.API_KEY_GOOGLE}&v=3.exp&libraries=geometry,drawing,places`,
//         loadingElement: <div style={{ height: `100%` }} />,
//         containerElement: <div style={{ height: `400px` }} />,
//         mapElement: <div style={{ height: `100%` }} />,
//     }),
//     withScriptjs,
//     withGoogleMap
// )((props) =>
//     <GoogleMap
//         defaultZoom={8}
//         defaultCenter={{ lat: -34.397, lng: 150.644 }}
//     >
//         {props.isMarkerShown &&
            // <Marker
            //     draggable={true}
            //     position={{ lat: -34.397, lng: 150.644 }}
            //     onClick={props.onMarkerClick} />
//         }
//     </GoogleMap>
// )

// export default class Map extends React.PureComponent {
//     state = {
//         isMarkerShown: false,
//     }

//     componentDidMount() {
//         this.delayedShowMarker()
//     }

//     delayedShowMarker = () => {
//         setTimeout(() => {
//             this.setState({ isMarkerShown: true })
//         }, 3000)
//     }

//     handleMarkerClick = () => {
//         this.setState({ isMarkerShown: false })
//         this.delayedShowMarker()
//     }

//     render() {
//         return (
//             <div className="App app-popup-show">
//                 <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
//                     <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
//                         <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
//                             <div className="popup-title">
//                                 <span style={{ color: 'black', fontSize: 18, }}>Pilih Lokasi</span>
//                             </div>
//                         </div>
//                         <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
//                             <button
//                                 type="button"
//                                 className="btn btn-circle btn-white"
//                                 onClick={() => this.props.onClose()}
//                             >
//                                 <img src={CloseImage} style={{ width: 20, height: 20 }} />
//                             </button>
//                         </div>
//                     </div>
//                     <div>
//                         <MyMapComponent
//                             isMarkerShown={this.state.isMarkerShown}
//                             onMarkerClick={this.handleMarkerClick}
//                         />
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }